import { sliderAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
  thumb: {
    bg: "White", // change the background of the thumb to orange.400
    width: "1.2rem",
    height: "1.2rem",
  },
  track: {
    height: ".6rem",
    borderRadius: "1rem",
    bg: "whiteAlpha.400",
  },
  filledTrack: {
    bg: "whiteAlpha.700",
  },
  mark: {
    px: ".2rem",
    py: ".2rem",
    bg: "white",
    mt: "-3rem",
    minW: "14",
    ml: "-5",
    color: "background",
    borderRadius: "1rem",
  },
});
export default defineMultiStyleConfig({ baseStyle });
